<app-invalid-license-for-action
  [iconTitle]="iconTitle()"
  [lockName]="pageName()"
  [lockType]="lockType()"
  (goProductChange)="close()"></app-invalid-license-for-action>
